import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';

export default function TabBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { cartCount, user } = useAppContext();
  const path = location.pathname;

  let tabs = [];

  if (user?.isSuperAdmin) {
    tabs = [
      { path: '/create-order', icon: '🧾', label: 'Оформление' },
      { path: '/', icon: '📋', label: 'Заказы' },
      { path: '/superadmin-chats', icon: '💬', label: 'Сообщения' },
      { path: '/profile', icon: '👤', label: 'Профиль' },
      { path: '/superadmin', icon: '⚙️', label: 'Управление' },
    ];
  } else if (user?.isAdmin) {
    tabs = [
      { path: '/create-order', icon: '🧾', label: 'Оформление' },
      { path: '/', icon: '📋', label: 'Заказы' },
      { path: '/profile', icon: '👤', label: 'Профиль' },
    ]; // Управление только у суперадмина
  } else {
    tabs = [
      { path: '/', icon: '🏠', label: 'Главная' },
      { path: '/catalog', icon: '💧', label: 'Каталог' },
      { path: '/cart', icon: '🛒', label: 'Корзина', badge: cartCount },
      { path: '/chat', icon: '💬', label: 'Чат' },
      { path: '/profile', icon: '👤', label: 'Профиль' },
    ];
  }

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)',
      width: '100%', maxWidth: 480,
      background: 'var(--tab-bar)', borderTop: '1px solid var(--border)',
      display: 'flex', height: 'calc(64px + env(safe-area-inset-bottom))',
      paddingBottom: 'env(safe-area-inset-bottom)',
      boxShadow: '0 -2px 8px rgba(0,0,0,0.06)',
    }}>
      {tabs.map(tab => {
        const active = path === tab.path || (tab.path !== '/' && path.startsWith(tab.path));
        return (
          <button key={tab.path} onClick={() => navigate(tab.path)} style={{
            flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
            justifyContent: 'center', gap: 2, background: 'none',
            color: active ? 'var(--primary)' : 'var(--text-light)',
            position: 'relative', cursor: 'pointer', border: 'none', outline: 'none',
          }}>
            <span style={{ fontSize: 22 }}>{tab.icon}</span>
            <span style={{ fontSize: 10, fontWeight: active ? 700 : 400 }}>{tab.label}</span>
            {tab.badge > 0 && (
              <span style={{
                position: 'absolute', top: 8, right: '22%',
                background: 'var(--primary)', color: '#fff',
                borderRadius: 10, minWidth: 18, height: 18,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 11, fontWeight: 700, padding: '0 4px',
              }}>{tab.badge}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
